/**
 * Flickity fade (vanilla) — no utils dependency
 * Fade between Flickity slides
 */

// ---- helpers ---- //
function modulo(n, m) {
  return ((n % m) + m) % m;
}

// ---- Slide ---- //
(function(Flickity) {
  if (!Flickity || !Flickity.Slide) return;

  var Slide = Flickity.Slide;

  Slide.prototype.renderFadePosition = function() {};

Slide.prototype.setOpacity = function(alpha) {
  this.cells.forEach(function(cell) {
    cell.element.style.opacity = alpha;
    cell.element.style.pointerEvents = alpha > 0.9 ? 'auto' : 'none';
  });
};


  // ---- Flickity ---- //
  var proto = Flickity.prototype;

  var updateSlides = proto.updateSlides;
  proto.updateSlides = function() {
    updateSlides.apply(this, arguments);
    if (!this.options.fade || !this.slides || !this.slides.length) return;

    this.slides.forEach(function(slide, i) {
      // position cells at selected target
      var slideTargetX = slide.target - slide.x;
      var firstCellX = slide.cells[0].x;

      slide.cells.forEach(function(cell) {
        var targetX = cell.x - firstCellX - slideTargetX;
        cell.element.style.transform = 'translateX(' + targetX + 'px)';
      });

      // set initial opacity
      var alpha = i === this.selectedIndex ? 1 : 0;
      slide.setOpacity(alpha);
    }, this);
  };

  /* ---- events ---- */

  proto.onSelectFade = function() {
    // keep fadeIndex in bounds
    this.fadeIndex = Math.min(this.prevSelectedIndex || 0, this.slides.length - 1);
    this.prevSelectedIndex = this.selectedIndex;
  };

  proto.onSettleFade = function() {
    delete this.didDragEnd;
    if (!this.options.fade || !this.slides || !this.slides.length) return;

    // selected full opacity
    if (this.selectedSlide) this.selectedSlide.setOpacity(1);

    // faded slide zero
    var fadedSlide = this.slides[this.fadeIndex];
    if (fadedSlide && this.fadeIndex !== this.selectedIndex) {
      fadedSlide.setOpacity(0);
    }
  };

  proto.onDragEndFade = function() {
    this.didDragEnd = true;
  };

  proto.onActivateFade = function() {
    if (!this.options.fade) return;

    this.element.classList.add('is-fade');

    // bind listeners once
    if (!this._fadeBound) {
      this.on('select', this.onSelectFade);
      this.on('settle', this.onSettleFade);
      this.on('dragEnd', this.onDragEndFade);
      // guard for visibility changes re-activations
      this._fadeBound = true;
    }

    // ensure initial state
    this.updateSlides();
    this.positionSliderAtSelected();
  };

  proto.onDeactivateFade = function() {
    if (!this.options.fade) return;
    this.element.classList.remove('is-fade');

    // reset opacity
    if (this.slides) {
      this.slides.forEach(function(slide) {
        slide.setOpacity('');
      });
    }

    // unbind (optional; keep if you recreate instances often)
    if (this._fadeBound) {
      this.off('select', this.onSelectFade);
      this.off('settle', this.onSettleFade);
      this.off('dragEnd', this.onDragEndFade);
      this._fadeBound = false;
    }
  };

  /* ---- position & fading ---- */

  var positionSlider = proto.positionSlider;
  proto.positionSlider = function() {
    if (!this.options.fade) {
      positionSlider.apply(this, arguments);
      return;
    }
    this.fadeSlides();
    this.dispatchScrollEvent();
  };

  var positionSliderAtSelected = proto.positionSliderAtSelected;
  proto.positionSliderAtSelected = function() {
    if (this.options.fade) {
      // position fade slider at origin
      this.setTranslateX(0);
    }
    positionSliderAtSelected.apply(this, arguments);
  };

  proto.fadeSlides = function() {
    if (!this.slides || this.slides.length < 2) return;

    var indexes = this.getFadeIndexes();
    var fadeSlideA = this.slides[indexes.a];
    var fadeSlideB = this.slides[indexes.b];
    if (!fadeSlideA || !fadeSlideB) return;

    var distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
    if (distance === 0) return;

    var progress = this.wrapDifference(fadeSlideA.target, -this.x) / distance;

    // clamp progress to avoid NaN/overshoot
    if (!isFinite(progress)) return;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    fadeSlideA.setOpacity(1 - progress);
    fadeSlideB.setOpacity(progress);

    // hide previous slide
    var fadeHideIndex = indexes.a;
    if (this.isDragging) {
      fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
    }
    var isNewHideIndex = this.fadeHideIndex !== undefined &&
      this.fadeHideIndex !== fadeHideIndex &&
      this.fadeHideIndex !== indexes.a &&
      this.fadeHideIndex !== indexes.b;

    if (isNewHideIndex && this.slides[this.fadeHideIndex]) {
      this.slides[this.fadeHideIndex].setOpacity(0);
    }
    this.fadeHideIndex = fadeHideIndex;
  };

  proto.getFadeIndexes = function() {
    if (!this.isDragging && !this.didDragEnd) {
      return { a: this.fadeIndex, b: this.selectedIndex };
    }
    return this.options.wrapAround
      ? this.getFadeDragWrapIndexes()
      : this.getFadeDragLimitIndexes();
  };

  proto.getFadeDragWrapIndexes = function() {
    var distances = this.slides.map(function(slide, i) {
      return this.getSlideDistance(-this.x, i);
    }, this);

    var absDistances = distances.map(function(distance) {
      return Math.abs(distance);
    });

    var minDistance = Math.min.apply(Math, absDistances);
    var closestIndex = absDistances.indexOf(minDistance);
    var distance = distances[closestIndex];
    var len = this.slides.length;

    var delta = distance >= 0 ? 1 : -1;
    return {
      a: closestIndex,
      b: modulo(closestIndex + delta, len)
    };
  };

  proto.getFadeDragLimitIndexes = function() {
    var dragIndex = 0;
    for (var i = 0; i < this.slides.length - 1; i++) {
      var slide = this.slides[i];
      if (-this.x < slide.target) break;
      dragIndex = i;
    }
    return { a: dragIndex, b: dragIndex + 1 };
  };

  proto.wrapDifference = function(a, b) {
    var diff = b - a;
    if (!this.options.wrapAround) return diff;

    var diffPlus = diff + this.slideableWidth;
    var diffMinus = diff - this.slideableWidth;
    if (Math.abs(diffPlus) < Math.abs(diff)) diff = diffPlus;
    if (Math.abs(diffMinus) < Math.abs(diff)) diff = diffMinus;
    return diff;
  };

  // ---- wrapAround ---- //
  var _updateWrapShiftCells = proto._updateWrapShiftCells;
  proto._updateWrapShiftCells = function() {
    if (this.options.fade) {
      this.isWrapping = this.getIsWrapping();
    } else {
      _updateWrapShiftCells.apply(this, arguments);
    }
  };

  var shiftWrapCells = proto.shiftWrapCells;
  proto.shiftWrapCells = function() {
    if (!this.options.fade) {
      shiftWrapCells.apply(this, arguments);
    }
  };

})(window.Flickity);
